import React, { useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useMatch } from "react-router-dom";
import Logo from "../../../components/logo";
import "./index.css";
import LogoutIcon from "@mui/icons-material/Logout";
import MobileFriendlyOutlinedIcon from "@mui/icons-material/MobileFriendlyOutlined";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import StyleIcon from "@mui/icons-material/Style";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DownloadSharp from "@mui/icons-material/DownloadSharp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SimCardIcon from "@mui/icons-material/SimCard";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import PaymentsIcon from "@mui/icons-material/Payments";
import Email from "@mui/icons-material/Email";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { motion } from "framer-motion";

const Aside = () => {
  const { pathname } = useLocation();
  const [section, setSection] = useState("");
  const [subSection, setSubSection] = useState("");
  const [user, setUser] = useState<any>(null);
  const [prevPathname, setPrevPathname] = useState(pathname);

  useEffect(() => {
    // Extract the current dropdown prefix from the URL
    const basePathSegment = pathname.split("/")[2];

    if (pathname !== prevPathname && subSection !== basePathSegment) {
      setSubSection("");
    }

    setPrevPathname(pathname);
  }, [pathname, subSection]);

  useEffect(() => {
    if (localStorage.getItem("user")) {
      setUser(JSON.parse(localStorage.getItem("user") || ""));
    }

    if (pathname.toLowerCase().indexOf("support") != -1) {
      setSection("support");
    }
    if (pathname.toLowerCase().indexOf("/thm") != -1) {
      setSection("thm");
    }
    if (pathname.toLowerCase().indexOf("/thm") != -1) {
      setSection("thm");
    } else if (pathname.toLowerCase().indexOf("/tha") != -1) {
      setSection("tha");
    } else if (pathname.toLowerCase().indexOf("/ivr") != -1) {
      setSection("ivr");
    }
  }, []);

  return (
    <motion.div
      initial={{ x: -10000 }}
      animate={{ x: 0 }}
      style={{ height: "100%" }}
      transition={{ ease: "easeOut", duration: 0.5 }}
    >
      <div className="asideInner">
        <Logo logoOuter={"logoOuter"} />
        <ul
          className="mainNav"
          style={{ overflow: "hidden auto", height: "calc(100% - 110px)" }}
        >
          {user &&
            user.Email &&
            (user.Email.indexOf("support") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.muzammil@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <span
                  onClick={() =>
                    setSection(section == "support" ? "" : "support")
                  }
                  className={section === "support" ? "disable" : ""}
                >
                  <SupportAgentIcon />
                  Support
                  <KeyboardArrowDownIcon className="arrowIcon" />
                </span>
              </li>
            )}

          {section === "support" &&
            user &&
            user.Email &&
            (user.Email.indexOf("support") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.muzammil@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <ul>
                  <li>
                    <NavLink
                      to="/support/portin"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <MobileFriendlyOutlinedIcon />
                      Check Account Details
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/calling-cards-detail"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AccountBalanceWalletIcon />
                      Calling Cards Detail
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/auto-renew"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AutorenewIcon />
                      Bundle
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/auto-topup"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <ArrowCircleUpIcon />
                      Topup
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/sim-replacement"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <SimCardIcon />
                      New Sim Number Replace
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/online-number-update"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <SimCardIcon />
                      Online Number Update
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/bulk-update"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <SimCardIcon />
                      Bulk Number Update
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/email-status"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <Email />
                      Email Status
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/support/add-bundle"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <ArrowCircleUpIcon />
                      Add Bundle
                    </NavLink>
                    {(user.Email.indexOf("admin-support") !== -1 ||
                      user.Email == "muhammad.muzammil@now.net.pk" ||
                      user.Email.indexOf("dev") !== -1 ||
                      user.Email == "rameez.hassan@now.net.pk" ||
                      user.Email == "tahir.shahzad@now.net.pk") && (
                      <NavLink
                        to="/support/detach-number"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <SimCardIcon />
                        Detach Number
                      </NavLink>
                    )}
                  </li>
                  <li>
                    <NavLink
                      to="/support/sim-request"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <SimCardIcon />
                      Sim Request
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/customerdetail-tha-thcc"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <SimCardIcon />
                      CustomerDetail for THA THCC
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/creditsim-status"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <SimCardIcon />
                      Credit Sim Status
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/freesim-status"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <SimCardIcon />
                      Free Sim Status
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/retry-method"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <SimCardIcon />
                      Retry Method
                    </NavLink>
                  </li>
                  {(user.Email.indexOf("support") !== -1 ||
                    user.Email.indexOf("dev") !== -1 ||
                    user.Email == "zohaib.mehboob@now.net.pk" ||
                    user.Email == "tahir.shahzad@now.net.pk" ||
                    user.Email == "muhammad.muzammil@now.net.pk" ||
                    user.Email == "rameez.hassan@now.net.pk") && (
                    <li>
                      <NavLink
                        to="/support/otp-verification"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <DomainVerificationIcon />
                        Otp Verification
                      </NavLink>
                    </li>
                  )}
                  {(user.Email.indexOf("dev") !== -1 ||
                    user.Email == "tahir.shahzad@now.net.pk" ||
                    user.Email == "muhammad.muzammil@now.net.pk" ||
                    user.Email == "rameez.hassan@now.net.pk") && (
                    <>
                      <li>
                        <NavLink
                          to="/support/imei-details"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <DomainVerificationIcon />
                          IMEI Details
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/support/usage-history"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <DomainVerificationIcon />
                          Usage History
                        </NavLink>
                      </li>
                    </>
                  )}
                  <li>
                    <NavLink
                      to="/support/download-invoice"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DownloadSharp />
                      Download Invoice
                    </NavLink>
                  </li>
                  {(user.Email == "aberisha@nowtel.co.uk" ||
                    user.Email.indexOf("admin-support") !== -1 ||
                    user.Email == "tahir.shahzad@now.net.pk" ||
                    user.Email == "muhammad.muzammil@now.net.pk" ||
                    user.Email.indexOf("dev") !== -1 ||
                    user.Email == "rameez.hassan@now.net.pk") && (
                    <li>
                      <NavLink
                        to="/support/view-msisdn"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <MobileFriendlyOutlinedIcon />
                        View Msisdn
                      </NavLink>
                    </li>
                  )}
                  {(user.Email.indexOf("admin-support") !== -1 ||
                    user.Email == "muhammad.muzammil@now.net.pk" ||
                    user.Email.indexOf("dev") !== -1 ||
                    user.Email == "rameez.hassan@now.net.pk" ||
                    user.Email == "tahir.shahzad@now.net.pk") && (
                    <li>
                      <NavLink
                        to="/support/cancel-fulfillment"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <CancelPresentationIcon />
                        Cancel Fulfillment
                      </NavLink>
                    </li>
                  )}
                  {(user.Email == "tahir.shahzad@now.net.pk" ||
                    user.Email == "rameez.hassan@now.net.pk") && (
                    <li>
                      <NavLink
                        to="/support/paypal-cancellation"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <CancelPresentationIcon />
                        Paypal Cancellation
                      </NavLink>
                    </li>
                  )}

                  <li>
                    <NavLink
                      to="/support/msisdn-status"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <MobileFriendlyOutlinedIcon />
                      Msisdn Status
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/etc-users"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <MobileFriendlyOutlinedIcon />
                      Etc Users
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/sim-dispatch"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <MobileFriendlyOutlinedIcon />
                      Sim Dispatch
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/portin-report"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      PortIn Report
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/audit-trail"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <VerifiedUserIcon />
                      Audit Trail
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/dtone-transactions"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AccountBalanceWalletIcon />
                      DT One Transactions
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/reloadly-transactions"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AccountBalanceWalletIcon />
                      Reloadly Transactions
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/trax-search-paypal"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AccountBalanceWalletIcon />
                      Paypal TRAX Search
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/support/trax-search-tha"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AccountBalanceWalletIcon />
                      THA TRAX Search
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/support/trax-search-thcc"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AccountBalanceWalletIcon />
                      THCC TRAX Search
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/trax-search-nowtel-card"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AccountBalanceWalletIcon />
                      Nowtel Card
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/support/thcc-thrcc-cdr"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AccountBalanceWalletIcon />
                      THCC/THRCC CDR
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/support/bundle-status"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AccountBalanceWalletIcon />
                      Bundle Refund & Cancellation Status
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
          {user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "aizaz.hussain@now.net.pk" ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk") && (
              <li>
                <span
                  onClick={() => setSection(section == "thm" ? "" : "thm")}
                  className={section === "thm" ? "disable" : ""}
                >
                  <SimCardIcon />
                  THM
                  <KeyboardArrowDownIcon className="arrowIcon" />
                </span>
              </li>
            )}
          {section === "thm" &&
            user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "aizaz.hussain@now.net.pk" ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk") && (
              <li>
                <ul>
                  <li>
                    <NavLink
                      to="/thm/dashboard"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DashboardIcon />
                      Dashboard
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/prepaid-sim-report"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Sim Order Report
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/portin-report"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      PortIn Report
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/portout-report"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Portout Report
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/paidcampaigns"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <PaymentsIcon />
                      Paid Campaign(s)
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/sales"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Bundle Sales
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/subscription-report"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Plan Subscription Reports
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/create-bundles"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <ArrowCircleUpIcon />
                      Create Bundles
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/portoutCustomerStatus"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Portout Customer Status
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/customerStatus"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Customer Status
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/faq-management"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Faq Management
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thm/sentiment-categories"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Sentiment Score & Categories
                    </NavLink>
                  </li>
                  {(user.Email.indexOf("dev") != -1 ||
                    user.Email.indexOf("marketing") !== -1 ||
                    user.Email == "tahir.shahzad@now.net.pk" ||
                    user.Email == "muhammad.ijaz@now.net.pk") && (
                    <li>
                      <NavLink
                        to="/thm/portouts-dashboard"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <AssessmentIcon />
                        PortOuts - Web Dashboard
                      </NavLink>
                    </li>
                  )}
                  {(user.Email.indexOf("dev") != -1 ||
                    user.Email.indexOf("admin") != -1 ||
                    user.Email == "aizaz.hussain@now.net.pk" ||
                    user.Email == "tahir.shahzad@now.net.pk") && (
                    <li>
                      <NavLink
                        to="/thm/payment-stats"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <DashboardIcon />
                        Payment Stats
                      </NavLink>
                    </li>
                  )}
                  {/* Reports Dropdown */}
                  <li>
                    <span
                      onClick={() => {
                        setSubSection((prev) =>
                          prev === "reports" ? "" : "reports",
                        );
                      }}
                      className={subSection === "reports" ? "disable" : ""}
                    >
                      <StyleIcon />
                      Reports
                      <KeyboardArrowDownIcon className="arrowIcon" />
                    </span>
                    {subSection === "reports" && (
                      <ul style={{ paddingLeft: "25px" }}>
                        <li>
                          <NavLink
                            to="/thm/reports/revenue-report"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <AssessmentIcon />
                            Revenue Report
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/thm/reports/plan-cohort-analysis"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <AssessmentIcon />
                            Plan Cohort Analysis
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                </ul>
              </li>
            )}

          {user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "asfand.yar@now.net.pk" ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk" ||
              user.Email == "azaz.manzoor@now.net.pk") && (
              <li>
                <span
                  onClick={() => setSection(section == "tha" ? "" : "tha")}
                  className={section === "tha" ? "disable" : ""}
                >
                  <SimCardIcon />
                  THA
                  <KeyboardArrowDownIcon className="arrowIcon" />
                </span>
              </li>
            )}
          {section === "tha" &&
            user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "asfand.yar@now.net.pk" ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk" ||
              user.Email == "azaz.manzoor@now.net.pk") && (
              <li>
                <ul>
                  <li>
                    <NavLink
                      to="/tha/activity-report"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DashboardIcon />
                      Signup Stats
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/tha/operator-cms"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DashboardIcon />
                      Operator CMS
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/tha/payment-stats"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DashboardIcon />
                      Payment Stats
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/tha/calling-report"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DashboardIcon />
                      Calling Report
                    </NavLink>
                  </li>

                  {(user.Email.indexOf("dev") != -1 ||
                    user.Email.indexOf("admin") != -1 ||
                    user.Email == "tahir.shahzad@now.net.pk" ||
                    user.Email == "rameez.hassan@now.net.pk") && (
                    <li>
                      <NavLink
                        to="/tha/delete-request"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <CancelPresentationIcon />
                        Delete Request
                      </NavLink>
                    </li>
                  )}
                  <li>
                    <NavLink
                      to="/tha/vendor-configuration"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Vendor Configuration
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/tha/transaction-details"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Transaction Details
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/tha/tha-cohort-report"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      THA Cohort Report
                    </NavLink>
                  </li>

                  {(user.Email == "tahir.shahzad@now.net.pk" ||
                    user.Email == "rameez.hassan@now.net.pk" ||
                    user.Email == "azaz.manzoor@now.net.pk" ||
                    user.Email == "marketing@crm-talkhome.com") && (
                    <li>
                      <NavLink
                        to="/tha/international-topup"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <AssessmentIcon />
                        International Topup Report
                      </NavLink>
                    </li>
                  )}
                  {(user.Email == "rameez.hassan@now.net.pk" ||
                    user.Email == "azaz.manzoor@now.net.pk") && (
                    <li>
                      <NavLink
                        to="/tha/welcome-offer"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <AssessmentIcon />
                        WelcomeOffer TopUp Report
                      </NavLink>
                    </li>
                  )}
                  <li>
                    <NavLink
                      to="/tha/popularity-rank"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Popular Products
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
          {user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk") && (
              <li>
                <span
                  onClick={() => setSection(section == "now" ? "" : "now")}
                  className={section === "now" ? "disable" : ""}
                >
                  <PaymentsIcon />
                  NOW
                  <KeyboardArrowDownIcon className="arrowIcon" />
                </span>
              </li>
            )}
          {section === "now" &&
            user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk") && (
              <li>
                <ul>
                  <li>
                    <NavLink
                      to="/now/payment-stats"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DashboardIcon />
                      Payment Stats
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
          {user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <span
                  onClick={() => setSection(section == "thcc" ? "" : "thcc")}
                  className={section === "thcc" ? "disable" : ""}
                >
                  <StyleIcon />
                  THCC
                  <KeyboardArrowDownIcon className="arrowIcon" />
                </span>
              </li>
            )}
          {section === "thcc" &&
            user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <ul>
                  <li>
                    <NavLink
                      to="/thcc/payment-stats"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DashboardIcon />
                      Payment Stats
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
          {user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "asfand.yar@now.net.pk" ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <span
                  onClick={() =>
                    setSection(section == "sendcredit" ? "" : "sendcredit")
                  }
                  className={section === "sendcredit" ? "disable" : ""}
                >
                  <StyleIcon />
                  Send Credit
                  <KeyboardArrowDownIcon className="arrowIcon" />
                </span>
              </li>
            )}
          {section === "sendcredit" &&
            user &&
            user.Email &&
            (user.Email.indexOf("marketing") !== -1 ||
              user.Email.indexOf("dev") !== -1 ||
              user.Email == "asfand.yar@now.net.pk" ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "muhammad.ijaz@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <ul>
                  <li>
                    <NavLink
                      to="/sendcredit/operator-cms"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DashboardIcon />
                      Operator CMS
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/sendcredit/daily-summary"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Daily Summary
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/sendcredit/top-products"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Top Products
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/sendcredit/customer-details"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Customer Details
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/sendcredit/transaction-details"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Transaction Details
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/sendcredit/check-balance"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Check Balance
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
          {user &&
            user.Email &&
            (user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <span
                  onClick={() =>
                    setSection(section == "fusionhub" ? "" : "fusionhub")
                  }
                  className={section === "fusionhub" ? "disable" : ""}
                >
                  <StyleIcon />
                  Fusion Hub
                  <KeyboardArrowDownIcon className="arrowIcon" />
                </span>
              </li>
            )}
          {section === "fusionhub" &&
            user &&
            user.Email &&
            (user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <ul>
                  <li>
                    <NavLink
                      to="/fusionhub/transaction-status"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Transaction Status
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/fusionhub/product-list"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Product List
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/fusionhub/sync-product"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Sync Product
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/fusionhub/user-details"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      User Details
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/fusionhub/operator-name"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Operator Name
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

          {user &&
            user.Email &&
            (user.Email.indexOf("dev") !== -1 ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <span
                  onClick={() =>
                    setSection(section == "promocode" ? "" : "promocode")
                  }
                  className={section === "promocode" ? "disable" : ""}
                >
                  <StyleIcon />
                  Promo Code
                  <KeyboardArrowDownIcon className="arrowIcon" />
                </span>
              </li>
            )}

          {section === "promocode" &&
            user &&
            user.Email &&
            (user.Email.indexOf("dev") !== -1 ||
              user.Email == "tahir.shahzad@now.net.pk" ||
              user.Email == "rameez.hassan@now.net.pk") && (
              <li>
                <ul>
                  <li>
                    <NavLink
                      to="/promocode/add-campaign"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Add Campaign
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/promocode/add-promocode"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <AssessmentIcon />
                      Add PromoCode
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

          {user && user.Email && user.Email == "ivr@now.net.pk" && (
            <li>
              <span
                onClick={() => setSection(section == "ivr" ? "" : "ivr")}
                className={section === "ivr" ? "disable" : ""}
              >
                <StyleIcon />
                IVR
                <KeyboardArrowDownIcon className="arrowIcon" />
              </span>
            </li>
          )}
          {section === "ivr" &&
            user &&
            user.Email &&
            user.Email == "ivr@now.net.pk" && (
              <li>
                <ul>
                  <li>
                    <NavLink
                      to="/ivr/ivr-logs"
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <DashboardIcon />
                      IVR Logs
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

          <li>
            <NavLink
              onClick={() => localStorage.removeItem("user")}
              to="/login"
            >
              <LogoutIcon />
              Logout
            </NavLink>
          </li>
        </ul>
      </div>
    </motion.div>
  );
};

export default Aside;
